<mat-table #table [dataSource]="angularMatData" multiTemplateDataRows matSort matSortDisableClear
           matSortActive="AttendanceDate"
           matSortDirection="desc" aria-label="Attendance Data Table" tabindex="0">
    <ng-container matColumnDef="More">
        <mat-header-cell *matHeaderCellDef style="min-width:68px;max-width:68px;text-align:center;"
                         translate class="print-ignore">More
        </mat-header-cell>
        <mat-cell *matCellDef="let attend" style="min-width:68px;max-width:68px;text-align:center;color:black;"
                  class="print-ignore">
            <span *ngIf="attend.AttendanceDetails.length > 0" aria-label="Expand row for more details">
                <i [ngClass]="checkExpanded(attend) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'" class="material-icons"
                   aria-hidden="true"></i>
            </span>
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="AttendanceDay">
        <mat-header-cell *matHeaderCellDef style="min-width:40px;max-width: 40px; white-space:nowrap;"></mat-header-cell>
        <mat-cell *matCellDef="let attend" [attr.tylerastid] = "'tblCell-' + attend.AttendanceDay" style="min-width:40px;max-width: 40px; white-space:nowrap;">
            <span translate>{{attend.AttendanceDate | date:'EEE'}}</span>
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="AttendanceDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
            <span translate>Date</span>
            <filter class="mat-filter" [data]="angularMatData" columnName="AttendanceDate" dataType="date"></filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let attend" [attr.tylerastid] = "'tblCell-' + attend.AttendanceDate">
            <span style="text-align: right;">{{attend.AttendanceDate | date: 'MM/dd/yy'}}</span>
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Type">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
            <span translate>Type</span>
            <filter class="mat-filter" [data]="angularMatData" columnName="Type" dataType="string"></filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let attend" [attr.tylerastid] = "'tblCell-' + attend.Type">
            <span translate>{{attend.Type}}</span>
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Duration">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
            <span translate>Duration</span>
            <filter class="mat-filter" [data]="angularMatData" columnName="Duration" dataType="string"></filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let attend" [attr.tylerastid] = "'tblCell-' + attend.Duration">{{attend.Duration}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="Codes">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
            <span translate>Codes</span>
            <filter class="mat-filter" [data]="angularMatData" columnName="Codes" dataType="string"></filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let attend" [attr.tylerastid] = "'tblCell-' + attend.Codes">{{attend.Codes}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="Days">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
            <span translate>Days</span>
            <filter class="mat-filter" [data]="angularMatData" columnName="Days" dataType="string"></filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let attend" [attr.tylerastid] = "'tblCell-' + attend.Days">{{attend.Days}}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="Hours">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
            <span translate>Hours</span>
            <filter class="mat-filter" [data]="angularMatData" columnName="Hours" dataType="number"></filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let attend" [attr.tylerastid] = "'tblCell-' + attend.Hours">{{attend.Hours}}</mat-cell>
    </ng-container>
    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let attend" [attr.colspan]="columnsToDisplayAttend.length" style="width:100%;"
            class="mat-detail-card">
            <by-date-details [attendanceType]="attend.Type" [attendanceDetails]="attend.AttendanceDetails" [calendarUseAttendanceTypes]="calendarUseAttendanceTypes"
                             *ngIf="angularMatData.checkVisible(attend)"></by-date-details>
        </td>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columnsToDisplayAttend; sticky:true">
    </mat-header-row>
    <mat-row *matRowDef="let row; columns: columnsToDisplayAttend" tabindex="0"
             [attr.aria-label]="getAriaRowByDate(row)"
             [ngStyle]="{'border-bottom-width':checkExpanded(row) ? '0px' : '1px'}"
             style="padding:0px;overflow: hidden;"
             matRipple (click)="toggleExpanded(row)" (keydown)="rowKeyPress($event, row)">
    </mat-row>
    <mat-row *matRowDef="let row; columns: ['expandedDetail']"
             [@detailExpand]="checkExpanded(row) && row.AttendanceDetails.length > 0 ? 'expanded' : 'collapsed'"
             (@detailExpand.start)="$event.toState == 'expanded' ? angularMatData.setVisible(row, true) : null"
             (@detailExpand.done)="$event.toState == 'collapsed' ? angularMatData.setVisible(row, false) : null"
             style="overflow: hidden"
             class="mat-detail-row">
    </mat-row>
</mat-table>

